const axios = require('axios')
const env = window.Cypress ? window.Cypress.env() : process.env

export default class LegacyClient {
  constructor () {
    this.client = axios.create({
      baseURL: env.VUE_APP_LEGACY_API
    })
  }

  getPracticeCalendarInfo ({ practiceId, track }) {
    const q = track ? '?fl=true' : ''
    return this.client.post(`/widgets/calendars/${practiceId}/0/0${q}`).then(response => {
      return response.data
    })
  }

  getCalendarInfo ({ providerId, locationId }) {
    return this.client.post(`widgets/calendars/0/${providerId}/${locationId}`).then(response => {
      return response.data
    })
  }

  makeAppointment (data) {
    return this.client.post('/widgets/appointment/make', data).then(response => {
      return response.data
    })
  }

  updateAppointment (data) {
    return this.client.post('/widgets/appointment/update', data).then(response => {
      return response.data
    })
  }

  getGoogleMapsApiKey ({ practiceId }) {
    const baseURL = env.VUE_APP_LEGACY_API.replace('://legacy.', '://api.')
    const apiClient = axios.create({
      baseURL
    })
    return apiClient.get(`/practice/${practiceId}/book-online-v2/google-maps-api-key`).then(response => {
      return response.data.google_maps_api_key
    })
  }
}
